import React from "react";
import styled from "styled-components";
import { useLang } from "../i18n/LanguageContext";

export default function LanguageToggle() {
  const { lang, toggle } = useLang();
  return (
    <Toggle onClick={toggle} aria-label="Change language">
      <span className={lang === "sq" ? "on" : ""}>SQ</span>
      <span className={lang === "en" ? "on" : ""}>EN</span>
    </Toggle>
  );
}

const Toggle = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  background: transparent;
  border: 1px solid ${({ theme }) => theme.colors.hair};
  border-radius: 100px;
  padding: 4px;
  cursor: pointer;
  span {
    font-size: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.inkSoft};
    padding: 4px 9px;
    border-radius: 100px;
    transition: 0.2s;
  }
  span.on {
    background: ${({ theme }) => theme.colors.green};
    color: ${({ theme }) => theme.colors.cream};
  }
`;
